import {Spin} from "../../__snowpack__/pkg/antd.js";
import React, {useCallback, useEffect} from "../../__snowpack__/pkg/react.js";
import {useState} from "../../__snowpack__/pkg/react.js";
export const ImageSpinner = ({url, alt}) => {
  const [loading, setLoading] = useState(false);
  const imageRef = useCallback((image) => {
    if (image !== null) {
      image.onload = () => {
        setLoading(false);
      };
      image.src = url;
      if (image.complete) {
        setLoading(false);
      }
    }
  }, []);
  useEffect(() => {
    setLoading(true);
  }, []);
  return /* @__PURE__ */ React.createElement(Spin, {
    spinning: loading
  }, /* @__PURE__ */ React.createElement("img", {
    ref: imageRef,
    alt,
    style: {width: "100%"}
  }));
};
